export const getBase64=(file)=> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

const toBase64 = file => new Promise((resolve, reject) => {  // convert file to base64;
    const reader = new FileReader();
    if(file){
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    }else{
        resolve(false)
    }
});

export const getBase64Arr = async (e)=>{ // push files to relative file array;
    
    let files64 = [];
    for(let file of [...e.target.files]){
      files64.push(await toBase64(file));
    }
    return files64;
}
